import React, { FC, ReactNode, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import * as amplitude from '@amplitude/analytics-browser';

import { useAppDispatch, useAppSelector } from 'application/store';
import { LoaderSkeleton } from 'application/components';
import { AuthActions } from 'application/store/Auth/actions';

import { getAuthTokenStorage } from 'common/auth/authService';

import { PathNames } from './constants';

export const ProtectedRoute: FC<{ children: ReactNode }> = ({ children }) => {
  const dispatch = useAppDispatch();
  const { tokens, user } = useAppSelector((state) => state.auth);
  const [token, setToken] = useState('');
  const [isLogin, setIsLogin] = useState(true);

  const fetchInvestorAccount = async () => {
    await dispatch(AuthActions.getInvestorAccount());
  };

  useEffect(() => {
    const getToken = async () => {
      setIsLogin(true);
      const accessToken = await getAuthTokenStorage();

      const token = accessToken ? accessToken.accessToken : tokens?.accessToken;
      setToken(token || '');
      setIsLogin(false);
    };
    getToken();
  }, [tokens]);

  useEffect(() => {
    if (token) {
      fetchInvestorAccount();
    }
  }, [token]);

  useEffect(() => {
    if (user) {
      amplitude.setUserId(user.email);
    }
  }, [user]);

  if (isLogin) {
    return <LoaderSkeleton />;
  }
  return <>{!token ? <Navigate to={PathNames.login} /> : children}</>;
};
